import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { fetchStates } from "../services/LocationService";

const ScheduleSearchSection: React.FC = () => {
  const navigate = useNavigate();
  const [selectedState, setSelectedState] = useState("");
  const [selectedWeek, setSelectedWeek] = useState("this");
  const [states, setStates] = useState<any[]>([]);

  useEffect(() => {
    loadStates();
  }, []);

  const loadStates = async () => {
    try {
      const statesData = await fetchStates();
      setStates(statesData);
    } catch (error) {
      console.error("Failed to load states");
    }
  };

  const handleSearch = () => {
    const params = new URLSearchParams();
    if (selectedState) params.append('state', selectedState);
    if (selectedWeek) params.append('week', selectedWeek);
    
    navigate(`/schedules?${params.toString()}`);
  };

  return (
    <section className="py-5" style={{ background: "linear-gradient(135deg, #ff6b6b 0%, #feca57 50%, #48dbfb 100%)" }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg={10}>
            <div className="text-center mb-4">
              <h2 className="display-5 fw-bold text-white mb-3">
                <i className="bi bi-calendar-event me-3" style={{ fontSize: "2.5rem" }}></i>
                Find Your Next Show
              </h2>
              <p className="lead text-white mb-4" style={{ fontSize: "1.2rem" }}>
                🎭 Discover amazing theater performances happening near you this week!
              </p>
            </div>
            
            <Card className="shadow-lg border-0 bg-white bg-opacity-95">
              <Card.Body className="p-5">
                <Row className="align-items-end g-4">
                  <Col lg={4}>
                    <Form.Label className="fw-bold text-dark mb-2">
                      <i className="bi bi-geo-alt-fill text-danger me-2"></i>
                      Select Your State
                    </Form.Label>
                    <Form.Select 
                      size="lg" 
                      value={selectedState} 
                      onChange={(e) => setSelectedState(e.target.value)}
                      className="border-2 border-warning"
                      style={{ borderRadius: "15px" }}
                    >
                      <option value="">🌍 All States</option>
                      {states.map((state) => (
                        <option key={state.stateCode} value={state.stateCode}>
                          📍 {state.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                  
                  <Col lg={4}>
                    <Form.Label className="fw-bold text-dark mb-2">
                      <i className="bi bi-calendar-week-fill text-primary me-2"></i>
                      Choose Week
                    </Form.Label>
                    <Form.Select 
                      size="lg" 
                      value={selectedWeek} 
                      onChange={(e) => setSelectedWeek(e.target.value)}
                      className="border-2 border-warning"
                      style={{ borderRadius: "15px" }}
                    >
                      <option value="this">📅 This Week</option>
                      <option value="next">⏭️ Next Week</option>
                      <option value="previous">⏮️ Previous Week</option>
                    </Form.Select>
                  </Col>
                  
                  <Col lg={4}>
                    <Button 
                      variant="warning" 
                      size="lg" 
                      className="w-100 py-3 fw-bold shadow-lg"
                      onClick={handleSearch}
                      style={{ 
                        borderRadius: "15px",
                        fontSize: "1.1rem",
                        background: "linear-gradient(45deg, #feca57, #ff9ff3)",
                        border: "none",
                        color: "#2c2c2c"
                      }}
                    >
                      <i className="bi bi-search me-2"></i>
                      🎪 Find Shows
                    </Button>
                  </Col>
                </Row>
                
                <div className="text-center mt-4">
                  <small className="text-muted">
                    ✨ Join thousands of theater lovers finding their perfect show!
                  </small>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ScheduleSearchSection;